<template>
    <Form
        class="DshForm"
        ref="form"
        :model="formData"
        :rules="showRules?rules:{}"
        @submit.native.prevent
    >
        <Row>
            <template v-for="(formItem) in formList">
                <i-col
                    v-if="isShow(formItem, formData)"
                    :key="formItem._key"
                    class="DshForm-item"
                    :span="formItem._br ? 24 : (formItem._span || 24)"
                >
                    <FormItem
                        :class="['DshForm-item-FormItem', formItemClass]"
                        :prop="formItem._key"
                    >
                        <dsh-formItem
                            :mode="mode"
                            :canEdit="canEdit"
                            :formData="formData"
                            :isShare="isShare"
                            :formItem="formItem"
                            :allFormList="allFormList"
                            :height="height"
                            :label-width="labelWidth"
                            :label-position="labelPosition"
                            :rowStyle="rowStyle"
                            :formControlClass="formControlClass"
                            @change="change(formItem, arguments)"
                            @click.native="clickControl(formItem)"
                            @changeField="changeField"
                        >
                            <slot
                                :mode="mode"
                                :canEdit="canEdit"
                                :formItem="formItem"
                                :formData="formData"
                                :allFormList="allFormList"
                            ></slot>

                            <slot
                                name="extra"
                                slot="extra"
                                :canEdit="canEdit"
                                :formItem="formItem"
                                :formData="formData"
                                :allFormList="allFormList"
                            ></slot>

                            <slot
                                name="corner"
                                slot="corner"
                                :canEdit="canEdit"
                                :formItem="formItem"
                                :formData="formData"
                                :allFormList="allFormList"
                            ></slot>
                        </dsh-formItem>
                    </FormItem>
                </i-col>

                <!-- 换行 -->
                <i-col
                    v-if="formItem._wrap"
                    :key="formItem._key + '_br'"
                    style="min-height: 0px;"
                    :span="24"
                ></i-col>
            </template>

            <div
                v-if="!formList.filter(formItem => isShow(formItem, formData)).length"
                class="dsh-tip"
            >{{ "---  无字段  ---" }}</div>
        </Row>
    </Form>
</template>

<script>
    export default {
        name: "DshForm",
        components: {},
        props: {
            mode: String,
            canEdit: {
                type: Boolean,
                default: true
            },
            formData: {
                type: Object,
                default () {
                    return {};
                }
            },
            formList: {
                type: Array,
                default () {
                    return [];
                }
            },
            allFormList: {
                type: Array,
                default () {
                    return [];
                }
            },
            height: [String, Number],
            labelWidth: [String, Number],
            labelPosition: String,
            rowStyle: Object,
            formItemClass: String,
            formControlClass: String,
            isShare: Boolean,
            showRules: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                rules: {},

                isShow (formItem, formData) {
                    // 寻找循环项
                    if (formItem._loop === true) {
                        Object.entries(formData).forEach(arr => {
                            if (!["_name", "_key", "_default", "_required", "_span", "_br", "_line", "_noLabel", "_displayType"].includes(arr[0])) {
                                this.$set(formItem, arr[0], arr[1]);
                            }
                        });
                    }

                    // 判断各项 依赖的值
                    if (formItem._key === "_default") {
                        // 不走依赖,解决配置端_default被隐藏的问题
                        return true;
                    } else if (formItem._displayType === "hide") {
                        return false;
                    } else {
                        if (!formItem._rely || !formItem._rely.length) {
                            return true;
                        } else {
                            // formItem的_relyLogic值为"and"、 "or"，默认的值是"and"；relyItem的_relyLogic存在的条件是formData[relyItem._key]值为数组 relyItem的_relyLogic为"in","contain"，默认值"in"
                            const isTrueFunc = relyItem => relyItem.val === undefined || (Array.isArray(relyItem.val) && !relyItem.val.length)
                                ? ![undefined, null, ""].includes(formData[relyItem._key])
                                : Array.isArray(relyItem.val)
                                    ? Array.isArray(formData[relyItem._key])
                                        ? relyItem._relyLogic === "contain"
                                            ? relyItem.val.every(valItem => formData[relyItem._key].includes(valItem))
                                            : relyItem.val.some(valItem => formData[relyItem._key].includes(valItem))

                                        : relyItem.val.includes(formData[relyItem._key])
                                    : relyItem.val === formData[relyItem._key];

                            if (formItem._relyLogic === "or" ? formItem._rely.some(isTrueFunc) : formItem._rely.every(isTrueFunc)) {
                                formData[formItem._key] = formData[formItem._key] !== undefined ? formData[formItem._key] : this.$deepCopy(formItem._default);
                                return true;
                            } else {
                                formData[formItem._key] = undefined;
                                return false;
                            }
                        }
                    }
                }
            };
        },
        computed: {},
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {
                this.initMonitor();
                this.initRules();
            },
            // 初始化监测
            initMonitor () {
                // 监测所有字段
                this.formList.forEach(formItem => {
                    this.$set(this.formData, formItem._key, this.formData[formItem._key]);
                });
            },
            // 初始化校验
            initRules () {
                this.formList.reduce((obj, formItem) => {
                    if (formItem._required) {
                        obj[formItem._key] = this.getRule(formItem);
                    }
                    return obj;
                }, this.rules);
            },

            // 发生改动
            change (formItem, params) {
                this.resetFormRules(formItem, params);
                this.$emit("change", formItem, ...params);
            },
            // 点击控件
            clickControl (formItem) {
                this.$emit("clickControl", formItem);
            },
            // 切换字段
            changeField (...params) {
                this.$emit("changeField", ...params);
            },

            /* 工具类 */
            // 获取校验数据
            getRule (formItem) {
                let valueTypeMap = {
                    number: "number",
                    switch: "boolean",
                    date: "date",
                    checkbox: "array",
                    cascader: "array",
                    region: "array",
                    coordinates: "object",
                    users: "array",
                    departments: "array",
                    file: "array",
                    reference: "object"
                };
                // 其他配置
                let subFieldsMap = {
                    coordinates: {
                        fields: {
                            lnglat: {
                                required: true,
                                type: "array",
                                message: `${formItem._name}为必填项！`
                            }
                        }
                    },
                    date: {
                        transform (value) {
                            let newVal = value;
                            if (value && typeof value === "string") {
                                return new Date(value);
                            }
                            return newVal;
                        }
                    }
                };

                let rules = [
                    {
                        required: true,
                        trigger: "blur, change",
                        message: `${formItem._name}为必填项！`,
                        // type: valueTypeMap[formItem._type] || "string",
                        type: formItem._type === "date" && formItem._dateType === "time" ? "string" : valueTypeMap[formItem._type] || "string",
                        ...(subFieldsMap[formItem._dateType !== "time" ? formItem._type : formItem._dateType] || {})
                    }
                ];

                // 正则校验
                let regMap = {
                    email: /^[0-9A-Za-z.@-_]{6,30}$/,
                    phone: /^[1][0-9]{10}$/,
                    mobilePhone: /^[1][0-9]{10}$/,
                    fixPhone: /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/,
                    idcard: /^([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)|(^[1-9]\d{5}(18|19|([2-9]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/,
                    url: /^(http:\/\/|^https:\/\/|^\/\/)((\w|=|\?|\.|\/|&|-)+)/g
                };
                // (formItem._type === "phone" && regMap[formItem._phoneType])
                if (regMap[formItem._type] || formItem.regStr) {
                    let reg = null;
                    if (formItem._type === "phone") {
                        reg = regMap[formItem._phoneType];
                    } else {
                        reg = regMap[formItem._type];
                    }
                    reg = formItem.regStr && new RegExp(formItem.regStr) || reg;

                    rules.push({
                        message: formItem.regMessage || `${formItem._name}格式不正确`,
                        trigger: "blur",
                        transform (value) {
                            if (!value || value === "") {
                                return value;
                            } else {
                                return reg.test(value) && value;
                            }
                        }
                    });
                }

                return rules;
            },
            // 强行执行一些校验
            resetFormRules (formItem, params) {
                const resetForms = ["file", "editor", "coordinates", "reference"];
                if (resetForms.includes(formItem._type) && formItem._required === true) {
                    this.$refs.form.validateField(formItem._key);
                }

            }
        },
        watch: {
            formList () {
                this.init();
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshForm {

    }
</style>
<style lang="less">
    .DshForm {
        &-item-FormItem {
            margin-bottom: 0px!important;
            // .ivu-form-item-content {
            //     line-height: 1.5;
            //     font-size: 18px;
            // }
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/form/DshForm.vue